<template>
    <div>
        <div :id="'Div' + nomeFormulario" :name="'Div' + nomeFormulario">
            <form :method="metodoFormulario" :action="linkAction" :id="nomeFormulario" :name="nomeFormulario" @submit.prevent="!visualizar && insereOuAtualiza()" novalidate>
                <div v-if="!edit">
                    <slot name="csrf">

                    </slot>
                </div>
                <input type="hidden" name="id_empresa" :value="cliente.id">

                <fieldset class="ec-form-secao">
                    <legend><b-icon icon="building"></b-icon> Identificação</legend>
                    <div class="form-row">
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="tipoCadastroPessoa" class="ec-obrigatorio">Tipo de cadastro</label>
                            <select :disabled="edit || visualizar" id="tipoCadastroPessoa" name="tipoCadastroPessoa" class="custom-select" v-model="tipoCadastro">
                                <option value="2">CNPJ</option>
                            </select>
                        </div>
                        <template v-if="cliente.CadastroTipo!=0 && cliente.CadastroTipo==2">
                            <div class="form-group col-sm-6 col-lg-3 ec-campo-switch">
                                <label for="cadastroAtivo">Situação</label>
                                <b-form-checkbox id="cadastroAtivo" v-model="cliente.ativo" name="cadastroAtivo" :value="'Ativo'" :unchecked-value="'Inativo'" :disabled="visualizar" :switch="true">
                                    {{ cliente.ativo=='Ativo' ? 'Ativa' : 'Inativa' }}
                                </b-form-checkbox>
                            </div>
                            <div class="form-group col-12">
                                <label for="InputCodigoEmpresa" class="ec-obrigatorio">Empresa</label>
                                <select :disabled="visualizar" id="InputCodigoEmpresa" name="InputCodigoEmpresa" class="custom-select" :class="{ 'is-invalid': errors.company_id }" v-model="codigoempresa">
                                    <option value="0">Selecione uma empresa</option>
                                    <option v-for="empresa in empresas" :value="empresa.id" :key="empresa.id">{{ empresa.nomecompleto }} - {{ empresa.nomereduzido }} - {{empresa.cnpj}}</option>
                                </select>
                                <div class="invalid-feedback" v-if="errors.company_id">{{ errors.company_id[0] }}</div>
                            </div>
                        </template>
                    </div>
                    <div class="form-row" v-if="cliente.CadastroTipo!=0 && cliente.CadastroTipo==2">
                        <div class="form-group col-lg-6">
                            <label for="inputRazaoSocial" class="ec-obrigatorio">Nome completo</label>
                            <input :readonly="visualizar" type="text" class="form-control" :class="{ 'is-invalid': errors.nomecompleto }" id="inputRazaoSocial" name="inputRazaoSocial" placeholder="Nome completo da unidade" v-model="cliente.nomecompleto">
                            <div class="invalid-feedback" v-if="errors.nomecompleto">{{ errors.nomecompleto[0] }}</div>
                        </div>
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="inputNomeFantasia" class="ec-obrigatorio">Nome reduzido</label>
                            <input :readonly="visualizar" type="text" maxlength="50" class="form-control" :class="{ 'is-invalid': errors.nomereduzido }" id="inputNomeFantasia" name="inputNomeFantasia" placeholder="Até 50 caracteres" v-model="cliente.nomereduzido">
                            <div class="invalid-feedback" v-if="errors.nomereduzido">{{ errors.nomereduzido[0] }}</div>
                        </div>
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="inputCNPJ" class="ec-obrigatorio">CNPJ</label>
                            <the-mask :readonly="visualizar" :masked="true" :mask="['##.###.###/####-##']" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.cnpj }" id="inputCNPJ" name="inputCNPJ" placeholder="00.000.000/0000-00" v-model="doc"/>
                            <div class="invalid-feedback" v-if="errors.cnpj">{{ errors.cnpj[0] }}</div>
                        </div>
                    </div>
                </fieldset>

                <template v-if="cliente.CadastroTipo!=0 && cliente.CadastroTipo==2">
                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="diagram-3"></b-icon> Códigos de integração</legend>
                        <p class="ec-form-secao__descricao">Identificadores desta unidade no ERP (GVDasa) e no CRM (Rubeus).</p>
                        <div class="form-row">
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputCodigoUnidade" class="ec-obrigatorio">Código da unidade (ERP)</label>
                                <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.codigounidade }" id="inputCodigoUnidade" name="inputCodigoUnidade" placeholder="Ex.: 1" v-model="cliente.codigounidade">
                                <div class="invalid-feedback" v-if="errors.codigounidade">{{ errors.codigounidade[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputCodigoUnidadepk" class="ec-obrigatorio">Código PK da unidade (ERP)</label>
                                <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.codigounidadepk }" id="inputCodigoUnidadepk" name="inputCodigoUnidadepk" placeholder="Ex.: 101" v-model="cliente.codigounidadepk">
                                <div class="invalid-feedback" v-if="errors.codigounidadepk">{{ errors.codigounidadepk[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputCodigoUnidadeexterno" class="ec-obrigatorio">Código da unidade (CRM)</label>
                                <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.codigounidadeexterno }" id="inputCodigoUnidadeexterno" name="inputCodigoUnidadeexterno" placeholder="Ex.: 44" v-model="cliente.codigounidadeexterno">
                                <div class="invalid-feedback" v-if="errors.codigounidadeexterno">{{ errors.codigounidadeexterno[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputOrigem">Origem (CRM)</label>
                                <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.origem }" id="inputOrigem" name="inputOrigem" placeholder="Ex.: 9" v-model="cliente.origem">
                                <div class="invalid-feedback" v-if="errors.origem">{{ errors.origem[0] }}</div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="telephone"></b-icon> Contato</legend>
                        <div class="form-row">
                            <div class="form-group col-lg-6">
                                <label for="inputEmail" class="ec-obrigatorio">E-mail</label>
                                <input :readonly="visualizar" type="email" autocomplete="email" class="form-control" :class="{ 'is-invalid': errors.email }" id="inputEmail" name="inputEmail" placeholder="contato@unidade.com.br" v-model="cliente.email">
                                <div class="invalid-feedback" v-if="errors.email">{{ errors.email[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputFone">Telefone</label>
                                <the-mask :readonly="visualizar" :masked="true" :mask="['(##)####-####','(##)#####-####']" type="tel" class="form-control" :class="{ 'is-invalid': errors.telefone }" id="inputFone" name="inputFone" placeholder="(00)0000-0000" v-model="cliente.telefone"/>
                                <div class="invalid-feedback" v-if="errors.telefone">{{ errors.telefone[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputCelular">Celular</label>
                                <the-mask :readonly="visualizar" :masked="true" :mask="['(##)####-####','(##)#####-####']" type="tel" class="form-control" id="inputCelular" name="inputCelular" placeholder="(00)00000-0000" v-model="cliente.celular"/>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="geo-alt"></b-icon> Endereço</legend>
                        <div class="form-row">
                            <div class="form-group col-sm-4 col-lg-2">
                                <label for="inputCep">CEP</label>
                                <the-mask :readonly="visualizar" :masked="true" :mask="['#####-###']" inputmode="numeric" class="form-control" id="inputCep" name="inputCep" placeholder="00000-000" v-model="cliente.cep"/>
                            </div>
                            <div class="form-group col-sm-8 col-lg-6">
                                <label for="inputEndereco">Logradouro</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputEndereco" name="inputEndereco" placeholder="Rua, avenida..." v-model="cliente.logradouro">
                            </div>
                            <div class="form-group col-4 col-lg-1">
                                <label for="inputNumero">Nº</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputNumero" name="inputNumero" placeholder="Nº" v-model="cliente.numero">
                            </div>
                            <div class="form-group col-8 col-lg-3">
                                <label for="inputComplemento">Complemento</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputComplemento" name="inputComplemento" placeholder="Sala, bloco..." v-model="cliente.complemento">
                            </div>
                            <div class="form-group col-sm-6 col-lg-4">
                                <label for="inputBairro">Bairro</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputBairro" name="inputBairro" placeholder="Bairro ou distrito" v-model="cliente.bairro">
                            </div>
                            <div class="form-group col-sm-6 col-lg-4">
                                <label for="inputCidade">Cidade</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputCidade" name="inputCidade" placeholder="Cidade" v-model="cliente.cidade">
                            </div>
                            <div class="form-group col-6 col-lg-2">
                                <label for="inputUF">UF</label>
                                <select :disabled="visualizar" id="inputUF" name="inputUF" class="custom-select" v-model="cliente.estado">
                                    <option value="">Selecione</option>
                                    <option v-for="uf in ufs" :key="uf" :value="uf">{{ uf }}</option>
                                </select>
                            </div>
                            <div class="form-group col-6 col-lg-2">
                                <label for="inputPais">País</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputPais" name="inputPais" placeholder="Brasil" v-model="cliente.pais">
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="plug"></b-icon> Integrações</legend>
                        <p class="ec-form-secao__descricao">Endereços e chaves de acesso usados na comunicação com o CRM (Rubeus) e o ERP (GVDasa).</p>
                        <div class="form-row">
                            <div class="form-group col-lg-6">
                                <label for="inputUrlApiRubeus">URL da API Rubeus</label>
                                <input :readonly="visualizar" type="url" spellcheck="false" autocomplete="off" class="form-control" :class="{ 'is-invalid': errors.urlapirubeus }" id="inputUrlApiRubeus" name="inputUrlApiRubeus" placeholder="https://..." v-model="cliente.urlapirubeus">
                                <div class="invalid-feedback" v-if="errors.urlapirubeus">{{ errors.urlapirubeus[0] }}</div>
                            </div>
                            <div class="form-group col-lg-6">
                                <label for="inputTokenApiRubeus">Token Rubeus</label>
                                <input :readonly="visualizar" type="text" spellcheck="false" autocomplete="off" class="form-control" :class="{ 'is-invalid': errors.tokenapirubeus }" id="inputTokenApiRubeus" name="inputTokenApiRubeus" placeholder="Token de acesso à API" v-model="cliente.tokenapirubeus">
                                <div class="invalid-feedback" v-if="errors.tokenapirubeus">{{ errors.tokenapirubeus[0] }}</div>
                            </div>
                            <div class="form-group col-lg-6">
                                <label for="inputUrlApiGvdasa">URL da API GVDasa</label>
                                <input :readonly="visualizar" type="url" spellcheck="false" autocomplete="off" class="form-control" :class="{ 'is-invalid': errors.urlapigvdasa }" id="inputUrlApiGvdasa" name="inputUrlApiGvdasa" placeholder="https://..." v-model="cliente.urlapigvdasa">
                                <div class="invalid-feedback" v-if="errors.urlapigvdasa">{{ errors.urlapigvdasa[0] }}</div>
                            </div>
                            <div class="form-group col-lg-6">
                                <label for="inputTokenApiGvdasa">Token GVDasa</label>
                                <input :readonly="visualizar" type="text" spellcheck="false" autocomplete="off" class="form-control" :class="{ 'is-invalid': errors.tokenapigvdasa }" id="inputTokenApiGvdasa" name="inputTokenApiGvdasa" placeholder="Token de acesso à API" v-model="cliente.tokenapigvdasa">
                                <div class="invalid-feedback" v-if="errors.tokenapigvdasa">{{ errors.tokenapigvdasa[0] }}</div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="grid"></b-icon> Módulos licenciados</legend>
                        <p class="ec-form-secao__descricao">Funcionalidades liberadas para esta unidade.</p>
                        <div class="form-row">
                            <div class="form-group col-sm-6 col-lg-4">
                                <b-form-checkbox id="oferta_processo_seletivo" v-model="cliente.oferta_processo_seletivo" name="oferta_processo_seletivo" :value="1" :unchecked-value="0" :disabled="visualizar" :switch="true">
                                    Oferta de processo seletivo
                                </b-form-checkbox>
                            </div>
                            <div class="form-group col-sm-6 col-lg-4">
                                <b-form-checkbox id="oferta_Inscricao_web" v-model="cliente.oferta_Inscricao_web" name="oferta_Inscricao_web" :value="1" :unchecked-value="0" :disabled="visualizar" :switch="true">
                                    Oferta de inscrição web
                                </b-form-checkbox>
                            </div>
                            <div class="form-group col-sm-6 col-lg-4">
                                <b-form-checkbox id="inscricao_web_aluno" v-model="cliente.inscricao_web_aluno" name="inscricao_web_aluno" :value="1" :unchecked-value="0" :disabled="visualizar" :switch="true">
                                    Inscrição do aluno
                                </b-form-checkbox>
                            </div>
                            <div class="form-group col-sm-6 col-lg-4">
                                <b-form-checkbox id="importar_parcela" v-model="cliente.importar_parcela" name="importar_parcela" :value="1" :unchecked-value="0" :disabled="visualizar" :switch="true">
                                    Importação de parcela
                                </b-form-checkbox>
                            </div>
                            <div class="form-group col-sm-6 col-lg-4">
                                <b-form-checkbox id="download_contrato" v-model="cliente.download_contrato" name="download_contrato" :value="1" :unchecked-value="0" :disabled="visualizar" :switch="true">
                                    Download de contrato
                                </b-form-checkbox>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="input-cursor-text"></b-icon> Máscaras de ofertas</legend>
                        <aviso-mascaras titulo="CONFIGURAÇÃO DE MÁSCARAS DE OFERTAS" cor="secondary"></aviso-mascaras>
                        <div class="form-row">
                            <div class="form-group col-lg-6">
                                <label for="inputmascarainscricao" :class="{ 'ec-obrigatorio': cliente.oferta_Inscricao_web==1 }">Máscara da oferta de inscrição</label>
                                <input :readonly="visualizar" type="text" spellcheck="false" class="form-control" :class="{ 'is-invalid': errors.mascarainscricao }" id="inputmascarainscricao" name="inputmascarainscricao" placeholder="Máscara da oferta de inscrição" v-model="cliente.mascaraofertainscricao">
                                <div class="invalid-feedback" v-if="errors.mascarainscricao">{{ errors.mascarainscricao[0] }}</div>
                            </div>
                            <div class="form-group col-lg-6">
                                <label for="inputmascarapse" :class="{ 'ec-obrigatorio': cliente.oferta_processo_seletivo==1 }">Máscara da oferta PSE</label>
                                <input :readonly="visualizar" type="text" spellcheck="false" class="form-control" :class="{ 'is-invalid': errors.mascarapse }" id="inputmascarapse" name="inputmascarapse" placeholder="Máscara da oferta de processo seletivo" v-model="cliente.mascaraofertapse">
                                <div class="invalid-feedback" v-if="errors.mascarapse">{{ errors.mascarapse[0] }}</div>
                            </div>
                        </div>
                    </fieldset>
                </template>

                <div class="ec-form-acoes">
                    <span class="ec-form-legenda" v-if="!visualizar">Campos obrigatórios</span>
                    <button v-if="!visualizar && cliente.id!=''" type="button" class="btn btn-outline-primary" @click="exportarUnidadeCrm(cliente)"><b-icon icon="cloud-upload"></b-icon> Exportar para Rubeus</button>
                    <button v-if="!visualizar && cliente.id!=''" type="button" class="btn btn-outline-primary" @click="exportarLocaisOfertaCrm(cliente)"><b-icon icon="geo"></b-icon> Exportar local de oferta</button>
                    <a :href="'/'+urlSistema" class="btn btn-outline-primary">{{ visualizar ? 'Voltar' : 'Cancelar' }}</a>
                    <button v-if="!visualizar" type="submit" class="btn btn-primary"><b-icon icon="check2"></b-icon> Salvar</button>
                </div>
            </form>
        </div>
        <modal-component titulo="Mensagem do Sistema" label-btn-fechar="OK" id="MensagemSistema" :url-redirect="'/'+urlSistema+'/'"  :sem-padding="true">
            <template v-slot:conteudo>
                <div class="ec-resumo">
                    <p class="ec-resumo__titulo">Unidade</p>
                    <div class="alert alert-success ec-resumo__alerta" role="alert">
                        <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                        <span v-if="edit">Atualizado com sucesso!</span>
                        <span v-else>Cadastrado com sucesso!</span>
                    </div>
                    <dl class="ec-resumo__ficha">
                        <dt>ID</dt>
                        <dd>{{ cliente.id }}</dd>
                        <dt>Nome</dt>
                        <dd>{{ cliente.nomecompleto || '—' }}</dd>
                        <dt>CNPJ</dt>
                        <dd>{{ cliente.cnpj || '—' }}</dd>
                    </dl>
                </div>
            </template>
        </modal-component>
        <modal-component titulo="Exportação CRM" label-btn-fechar="OK" id="ExportacaoCrmMsg" :url-redirect="'/'+urlSistema+'/'" :sem-padding="true">
            <template v-slot:titulo>
                Exportação CRM
            </template>
            <template v-slot:conteudo>
                <div class="ec-resumo">
                    <p class="ec-resumo__titulo">Unidade</p>
                    <div class="alert alert-success ec-resumo__alerta" role="alert">
                        <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                        <span>Unidade exportada para o CRM</span>
                    </div>
                    <dl class="ec-resumo__ficha">
                        <dt>Código</dt>
                        <dd>{{ unidade_exportada_crm.codigo || '—' }}</dd>
                        <dt>ID de exportação</dt>
                        <dd>{{ unidade_exportada_crm.id || '—' }}</dd>
                        <dt>Descrição</dt>
                        <dd>{{ unidade_exportada_crm.descricao || '—' }}</dd>
                    </dl>
                </div>
            </template>
        </modal-component>
        <modal-component titulo="Exportação CRM" label-btn-fechar="OK" id="ExportacaoCrmMsgLocalOferta" :url-redirect="'/'+urlSistema+'/'" :sem-padding="true">
            <template v-slot:titulo>
                Exportação CRM
            </template>
            <template v-slot:conteudo>
                <div class="ec-resumo">
                    <p class="ec-resumo__titulo">Unidade</p>
                    <div class="alert alert-success ec-resumo__alerta" role="alert">
                        <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                        <span>Unidade exportada como local de oferta no CRM</span>
                    </div>
                    <dl class="ec-resumo__ficha">
                        <dt>Código</dt>
                        <dd>{{ local_oferta_crm.codigounidade || '—' }}</dd>
                        <dt>ID de exportação</dt>
                        <dd>{{ local_oferta_crm.codigolocaloferta || '—' }}</dd>
                        <dt>Unidade</dt>
                        <dd>{{ local_oferta_crm.nomecompleto || '—' }}</dd>
                    </dl>
                </div>
            </template>
        </modal-component>
        <loading id="SalvandoUnity" titulo="Salvando Unidade, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
        
    </div>
</template>

<script>


export default{

    methods:{
        dissmiss(id){
            this.$bvModal.hide(id);
        },
        novo(id){
            this.user = {}
            this.modoeditar = false
            this.modoexcluir = false
            this.modonovo = true
            this.texto_modal = "Novo"
            this.user.id=id
            // console.log(this.user)
        },
        editar(usuarioSelecionado){
            this.user = usuarioSelecionado;
            this.modoeditar = true
            this.modoexcluir = false
            this.modonovo = false
            this.texto_modal = "Editar"
            // console.log(this.user)
            // console.log(this.user)
        },
        excluir(usuarioSelecionado){
            this.user = usuarioSelecionado;
            this.modoeditar = false
            this.modoexcluir = true
            this.modonovo = false
            this.texto_modal = "Excluir"
            // console.log(this.user)
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        resetModal() {
            this.name = ''
            this.nameState = null
        },
        removerPorId: function (id) {
            var _vm = this; //Adicionando a instância à uma variável, para que possa ser acessada dentro do forEach`
            this.users.forEach(function(el, index) {
                if(el.id === id)
                    _vm.users.splice(index, 1);
            })
        },
        insereOuAtualiza(){
            if(!this.edit){
                this.inserirUnity();
                console.log('insere')
            }else{
                this.atualizaUnity();
                console.log('atualiza')
            }
        },
        inserirUnity(){
            // if(this.modonovo){
                $('#SalvandoUnity').modal('show');
                let url='/api/v1/'+this.urlSistema;
                let formData = new FormData();
                formData.append('tipocadastro', this.tipoCadastro)
                formData.append('company_id', (this.cliente.company_id?this.cliente.company_id:''))
                formData.append('codigounidade', (this.cliente.codigounidade?this.cliente.codigounidade:''))
                formData.append('codigounidadepk', (this.cliente.codigounidadepk?this.cliente.codigounidadepk:''))
                formData.append('codigounidadeexterno', (this.cliente.codigounidadeexterno?this.cliente.codigounidadeexterno:''))
                formData.append('nomecompleto', (this.cliente.nomecompleto?this.cliente.nomecompleto:''))
                formData.append('cnpj', (this.cliente.cnpj?this.cliente.cnpj:''))
                formData.append('email', (this.cliente.email?this.cliente.email:''))
                formData.append('telefone', (this.cliente.telefone?this.cliente.telefone:''))
                formData.append('celular', (this.cliente.celular?this.cliente.celular:''))
                formData.append('logradouro', (this.cliente.logradouro?this.cliente.logradouro:''))
                formData.append('numero', (this.cliente.numero?this.cliente.numero:''))
                formData.append('complemento', (this.cliente.complemento?this.cliente.complemento:''))
                formData.append('bairro', (this.cliente.bairro?this.cliente.bairro:''))
                formData.append('cidade', (this.cliente.cidade?this.cliente.cidade:''))
                formData.append('estado', (this.cliente.estado && this.cliente.estado != '0' ?this.cliente.estado:''))
                formData.append('pais', (this.cliente.pais && this.cliente.pais != '0' ?this.cliente.pais:''))
                formData.append('cep', (this.cliente.cep?this.cliente.cep:''))
                formData.append('urlapirubeus', (this.cliente.urlapirubeus?this.cliente.urlapirubeus:''))
                formData.append('tokenapirubeus', (this.cliente.tokenapirubeus?this.cliente.tokenapirubeus:''))
                formData.append('urlapigvdasa', (this.cliente.urlapigvdasa?this.cliente.urlapigvdasa:''))
                formData.append('tokenapigvdasa', (this.cliente.tokenapigvdasa?this.cliente.tokenapigvdasa:''))

                formData.append('oferta_processo_seletivo', (this.cliente.oferta_processo_seletivo?this.cliente.oferta_processo_seletivo:0))
                formData.append('oferta_Inscricao_web', (this.cliente.oferta_Inscricao_web?this.cliente.oferta_Inscricao_web:0))
                formData.append('inscricao_web_aluno', (this.cliente.inscricao_web_aluno?this.cliente.inscricao_web_aluno:0))
                formData.append('importar_parcela', (this.cliente.importar_parcela?this.cliente.importar_parcela:0))
                formData.append('download_contrato', (this.cliente.download_contrato?this.cliente.download_contrato:0))
                formData.append('ativo',(this.cliente.ativo=='Ativo'?'1':'0'))
                formData.append('origem', (this.cliente.origem?this.cliente.origem:''))
                formData.append('mascarainscricao', (this.cliente.mascaraofertainscricao?this.cliente.mascaraofertainscricao:''))
                formData.append('mascarapse', (this.cliente.mascaraofertapse?this.cliente.mascaraofertapse:''))
                formData.append('codigotipocontatotelefone', (this.cliente.codigotipocontatotelefone?this.cliente.codigotipocontatotelefone:''))
                formData.append('codigotipocontatoemail', (this.cliente.codigotipocontatoemail?this.cliente.codigotipocontatoemail:''))
                if(this.tipoCadastro==2){
                    formData.append('nomereduzido', (this.cliente.nomereduzido?this.cliente.nomereduzido:''))
                }else{
                    formData.append('nomereduzido', '')
                }
                formData.append('email',(this.cliente.email?this.cliente.email:''))

                let configuracao = {
                    // method:'post',
                    // headers:{
                    //     // // 'Accept': 'application/json',
                    //     // // 'Authorization': this.$root.token(),
                    // }
                }
                
                axios.post(url,formData,configuracao)
                    .then(response => {
                        this.transacaoStatus = response.status
                        this.cliente = response.data.usuarioNovo;
                        this.cliente.ativo = (this.cliente.ativo=='Ativo'?'Ativo':'Inativo')
                        this.errors={};
                        this.cliente.CadastroTipo=2
                        $('#SalvandoUnity').modal('hide');
                        $('#MensagemSistema').modal('show');
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response)
                        $('#SalvandoUnity').modal('hide');
                    })
            // }
        },
        atualizaUnity(){
            // if(this.modonovo){
                $('#SalvandoUnity').modal('show');
                let url='/api/v1/'+this.urlSistema+'/'+this.cliente.id;
                //console.log(this.cliente)                                  
                let formData = new FormData();
                formData.append('_method','patch');
                formData.append('tipocadastro', this.tipoCadastro)
                formData.append('company_id', (this.cliente.company_id?this.cliente.company_id:''))
                formData.append('codigounidade', (this.cliente.codigounidade?this.cliente.codigounidade:''))
                formData.append('codigounidadepk', (this.cliente.codigounidadepk?this.cliente.codigounidadepk:''))
                formData.append('codigounidadeexterno', (this.cliente.codigounidadeexterno?this.cliente.codigounidadeexterno:''))
                formData.append('nomecompleto', (this.cliente.nomecompleto?this.cliente.nomecompleto:''))
                formData.append('cnpj', (this.cliente.cnpj?this.cliente.cnpj:''))
                formData.append('email', (this.cliente.email?this.cliente.email:''))
                formData.append('telefone', (this.cliente.telefone?this.cliente.telefone:''))
                formData.append('celular', (this.cliente.celular?this.cliente.celular:''))
                formData.append('logradouro', (this.cliente.logradouro?this.cliente.logradouro:''))
                formData.append('numero', (this.cliente.numero?this.cliente.numero:''))
                formData.append('complemento', (this.cliente.complemento?this.cliente.complemento:''))
                formData.append('bairro', (this.cliente.bairro?this.cliente.bairro:''))
                formData.append('cidade', (this.cliente.cidade?this.cliente.cidade:''))
                formData.append('estado', (this.cliente.estado && this.cliente.estado != '0' ?this.cliente.estado:''))
                formData.append('pais', (this.cliente.pais && this.cliente.pais != '0' ?this.cliente.pais:''))
                formData.append('cep', (this.cliente.cep?this.cliente.cep:''))
                formData.append('urlapirubeus', (this.cliente.urlapirubeus?this.cliente.urlapirubeus:''))
                formData.append('tokenapirubeus', (this.cliente.tokenapirubeus?this.cliente.tokenapirubeus:''))
                formData.append('urlapigvdasa', (this.cliente.urlapigvdasa?this.cliente.urlapigvdasa:''))
                formData.append('tokenapigvdasa', (this.cliente.tokenapigvdasa?this.cliente.tokenapigvdasa:''))

                formData.append('oferta_processo_seletivo', (this.cliente.oferta_processo_seletivo?this.cliente.oferta_processo_seletivo:0))
                formData.append('oferta_Inscricao_web', (this.cliente.oferta_Inscricao_web?this.cliente.oferta_Inscricao_web:0))
                formData.append('inscricao_web_aluno', (this.cliente.inscricao_web_aluno?this.cliente.inscricao_web_aluno:0))
                formData.append('importar_parcela', (this.cliente.importar_parcela?this.cliente.importar_parcela:0))
                formData.append('download_contrato', (this.cliente.download_contrato?this.cliente.download_contrato:0))
                formData.append('ativo',(this.cliente.ativo=='Ativo'?'1':'0'))
                formData.append('origem', (this.cliente.origem?this.cliente.origem:''))
                formData.append('mascarainscricao', (this.cliente.mascaraofertainscricao?this.cliente.mascaraofertainscricao:''))
                formData.append('mascarapse', (this.cliente.mascaraofertapse?this.cliente.mascaraofertapse:''))
                formData.append('codigotipocontatotelefone', (this.cliente.codigotipocontatotelefone?this.cliente.codigotipocontatotelefone:0))
                formData.append('codigotipocontatoemail', (this.cliente.codigotipocontatoemail?this.cliente.codigotipocontatoemail:0))
                if(this.tipoCadastro==2){
                    formData.append('nomereduzido', (this.cliente.nomereduzido?this.cliente.nomereduzido:''))
                }else{
                    formData.append('nomereduzido', '')
                }
                formData.append('email',(this.cliente.email?this.cliente.email:''))
                
                let configuracao = {
                    // method:'put',
                    // headers:{
                    // //     'Accept': 'application/json',
                    // //     'Authorization': this.$root.token()
                    // },
                }
                
                axios.post(url, formData,configuracao)
                    .then(response => {
                        // console.log(response)
                        this.transacaoStatus = response.status
                        this.cliente = response.data.usuarioNovo;
                        this.cliente.ativo = response.data.usuarioNovo.ativo
                        this.errors={};
                        this.cliente.CadastroTipo=2
                        this.tipoCadastro=2;
                        $('#SalvandoUnity').modal('hide');
                        $('#MensagemSistema').modal('show');
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response.data)
                        $('#SalvandoUnity').modal('hide');
                    })
            // }
        },
        excluirUsuarioCliente(id){
            
            if(this.modoexcluir){
                var config = {
                method: 'delete',
                url: '/api/v1/'+this.urlSistema+'/'+id,
                // headers: {
                //         // 'Accept': 'application/json',
                //         // 'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                    debugger;
                    // console.log(response.data.usuario)
                    this.$bvModal.hide('modal-prevent-closing')
                    this.$nextTick(() => {
                        window.alert("Usuário de Cliente excluído com sucesso");
                    })
                    this.removerPorId(id)
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        },
        exportarLocaisOfertaCrm(unidade){
            let url='/api/v1/Companies/Unity/CadastroLocaisOferta/'+this.cliente.id;
                
                //console.log(this.cliente)                                  
                
                
            let configuracao = {
                // method:'put',
                // headers:{
                // //     'Accept': 'application/json',
                // //     'Authorization': this.$root.token()
                // },
            }
            
            axios.post(url,configuracao)
                .then(response => {
                    this.local_oferta_crm = response.data
                    console.log(this.local_oferta_crm)
                    // this.empresa_exportada_crm.id = response.data.resposta_crm.id
                    $('#ExportacaoCrmMsgLocalOferta').modal('show');
                })
                .catch(errors => {
                    this.errors = errors.response.data.errors
                    console.log(errors.response.data)
                })
        },
        exportarUnidadeCrm(unidade){
            let url='/api/v1/Crm/cadastroUnidade/'+this.cliente.id;
                
                //console.log(this.cliente)                                  
                
                
            let configuracao = {
                // method:'put',
                // headers:{
                // //     'Accept': 'application/json',
                // //     'Authorization': this.$root.token()
                // },
            }
            
            axios.post(url,configuracao)
                .then(response => {
                    console.log(response)
                    this.unidade_exportada_crm = response.data.dadosUnidade
                    this.unidade_exportada_crm.id = response.data.resposta_crm.id
                    $('#ExportacaoCrmMsg').modal('show');
                })
                .catch(errors => {
                    this.errors = errors.response.data.errors
                    console.log(errors.response.data)
                })
        }
    },
    mounted(){
        // this.$root.atualizaCookie('token');
    },
    created(){

        if(this.pessoa){
            this.cliente = this.pessoa;
            this.codigoempresa = this.pessoa.company_id;
            console.log(this.cliente)
            this.users = this.usuarios;
            this.doc=this.pessoa.cnpj;
            if(this.pessoa.cnpj.length==14){
                this.cliente.CadastroTipo=1
                this.cliente.cnpj = this.pessoa.cnpj;
                this.tipoCadastro=1
            }else if(this.pessoa.cnpj.length==18){
                this.cliente.CadastroTipo=2
                this.cliente.cnpj = this.pessoa.cnpj;
                this.tipoCadastro=2
            }else{
                this.cliente.CadastroTipo=2
                this.tipoCadastro=2
            }
        }else{
            this.cliente.CadastroTipo=0;
            this.tipoCadastro=0;
            this.cliente.estado="0";
            this.codigoempresa=0;
        }
    },
    props:{
        urlSistema:{
            type:String,
            required:true
        },
        visualizar:{
            type:Boolean,
            required:true
        },
        nomeFormulario:{
            type:String,
            required:true
        },
        metodoFormulario:{
            type:String,
            required:true
        },
        linkAction:{
            type:String,
            required:true
        },
        pessoa:{
            type:Object,
            required:false
        },
        empresas:{
            type:Array,
            required:true
        },
        usuarioAutenticado:{
            type:Object,
            required:false
        },
        usuarios:[],
        edit:{
            type:Boolean,
            required:true
        }
    },
    watch: {
    // whenever question changes, this function will run
        codigoempresa(newempresa,oldempresa){
            if(newempresa!=oldempresa){
                this.cliente.company_id = newempresa
            }
        },
        texto_modal(newTexto, oldTtexto) {
            if (newTexto!=oldTtexto) {
                this.texto_modal=newTexto;
            }
        }
        ,tipoCadastro(newTipoCadastro, oldTipoCadastro) {
            if (newTipoCadastro!=oldTipoCadastro) {
                this.cliente.CadastroTipo=newTipoCadastro;
                this.tipoCadastro=newTipoCadastro;
                this.errors={};
            }
        },
        'cliente.ativo'(newcliente,oldcliente){
            console.log(newcliente);
        },
        doc(newdoc, olddoc) {
            if (newdoc!=olddoc) {
                this.cliente.cnpj=newdoc;
                this.doc=newdoc;
            }
        },
    },
    data(){
        return{
            ufs:['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'],
            transacaoStatus:null,
            modonovo:false,
            modoeditar:false,
            modoexcluir:false,
            Novo:false,
            texto_modal:'',
            nameState: null,
            senhaState:null,
            emailState:null,
            submittedNames: [],
            tipoCadastro:null,
            doc:null,
            codigoempresa:0,
            cliente:{
                id:null,
                nomecompleto:null,
                nomereduzido:null,
                cnpj:null,
                logradouro:null,
                numero:null,
                complemento:null,
                cep:null,
                pais:null,
                estado:null,
                cidade:null,
                bairro:null,
                site:null,
                email:null,
                telefone:null,
                celular:null,
                codigounidade:null,
                codigounidadepk:null,
                company_id:null,
                ativo:null,
                origem:null,
                /**
                 * cpf = 1
                 * cnpj = 2
                 */
                CadastroTipo:0,
                // link_integracao_gvdasa:null,
                // token_api_gvdasa:null,
                // link_integracao_rubeus:null,
                // token_api_rubeus:null,
                // origem:null,

            },
            user:{
                id:null,
                name:null,
                email:null,
                senha:null,
            },
            unidade_exportada_crm:[{
                id:null,
                codigo:null,
                descricao:null,
                nome:null,
                oridem:null
            }],
            local_oferta_crm:[{
                id:null,
                codigo:null,
                descricao:null,
                nome:null,
                oridem:null
            }],
            users:[],
            errors:{}
        }
    }
}
</script>

<style scoped>
    form{
        text-align: left!important;
    }


    /* resumo do registro no modal de confirmação (rótulo à esquerda, valor à direita; empilha no celular) */
    .ec-resumo {
        text-align: left;
    }

    .ec-resumo__titulo {
        margin: 0;
        padding: .75rem 1.25rem;
        border-bottom: 1px solid #e3e9ed;
        font-size: .78rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: #1c4d5a;
    }

    .ec-resumo__alerta {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: .5rem;
        margin: 0;
        border-width: 0 0 1px;
        border-radius: 0;
        font-weight: 600;
    }

    .ec-resumo__ficha {
        display: grid;
        grid-template-columns: max-content 1fr;
        gap: .45rem 1rem;
        margin: 0;
        padding: 1rem 1.25rem;
    }

    .ec-resumo__ficha dt {
        align-self: center;
        font-size: .68rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: #64767c;
    }

    .ec-resumo__ficha dd {
        margin: 0;
        font-weight: 600;
        overflow-wrap: anywhere;
        font-variant-numeric: tabular-nums;
    }

    @media (max-width: 575.98px) {
        .ec-resumo__ficha { grid-template-columns: 1fr; gap: .1rem; }
        .ec-resumo__ficha dd { margin-bottom: .5rem; }
        .ec-resumo__ficha dd:last-child { margin-bottom: 0; }
    }
</style>
